module.exports = __webpack_public_path__ + "media/mobile/advanced-select-search-adf82e2c.svg";